import React from "react";
import { Skeleton } from "@/components/atomic/Skeleton";
import { cn } from "@/lib/utils";

interface MessageSkeletonProps {
  count?: number;
  className?: string;
}

// ユーザーメッセージのスケルトン（右寄り）
const UserMessageSkeleton: React.FC<{ className?: string; }> = ({ className }) => {
  return (
    <div className={cn("group relative mb-4 flex justify-end", className)}>
      <div className="flex-1 max-w-[40%] relative group/message py-3 px-4 rounded-2xl bg-[#e9e9e980]">
        <Skeleton className="h-4 w-full mb-2 bg-[#00000012]" />
        <Skeleton className="h-4 w-[80%] bg-[#00000012]" />
      </div>
    </div>
  );
};

// アシスタントメッセージのスケルトン（左寄り）
const AssistantMessageSkeleton: React.FC<{ className?: string; }> = ({ className }) => {
  return (
    <div className={cn("group relative mb-4 flex justify-start", className)}>
      <div className="flex flex-col items-start flex-1">
        <div className="prose prose-sm w-full">
          <Skeleton className="h-4 w-[80%] mb-2 bg-[#0000000f]" />
          <Skeleton className="h-4 w-[75%] mb-2 bg-[#0000000f]" />
          <Skeleton className="h-4 w-[60%] mb-4 bg-[#0000000f]" />
          <Skeleton className="h-6 w-[30%] mb-4 bg-[#0000000f]" />
          <Skeleton className="h-4 w-[75%] mb-2 bg-[#0000000f]" />
          <Skeleton className="h-4 w-[60%] mb-2 bg-[#0000000f]" />
          <Skeleton className="h-4 w-[40%] bg-[#0000000f]" />
        </div>
      </div>
    </div>
  );
};

// メッセージスケルトンコンポーネント
const MessageSkeleton: React.FC<MessageSkeletonProps> = ({
  count = 3,
  className,
}) => {
  return (
    <div className={cn("space-y-4", className)}>
      {Array.from({ length: count }, (_, index) => {
        // ユーザーとアシスタントのメッセージを交互に表示
        const isUserMessage = index % 2 === 0;
        return isUserMessage
          ? <UserMessageSkeleton key={`user-${index}`} />
          : <AssistantMessageSkeleton key={`assistant-${index}`} />;
      })}
    </div>
  );
};

export { AssistantMessageSkeleton, MessageSkeleton, UserMessageSkeleton };
